export const verifyFeatureAccess = (features, feature) => {
  const access = features ? features[feature] : false

  if (access === undefined || access === true) {
    return true
  }

  return false
}
